import { render, staticRenderFns } from "./xingyou.vue?vue&type=template&id=a8385d12&scoped=true"
import script from "./xingyou.vue?vue&type=script&lang=js"
export * from "./xingyou.vue?vue&type=script&lang=js"
import style0 from "./xingyou.vue?vue&type=style&index=0&id=a8385d12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8385d12",
  null
  
)

export default component.exports